import React, { Fragment } from 'react';
import CustomTable from '@jumbo/components/CustomTable';
import { Visibility, Edit, Mail } from '@material-ui/icons';
import Dialog from '@material-ui/core/Dialog';
import { Chip } from '@material-ui/core';
// import EnhancedTable from '@jumbo/components/EnhancedTable';

function createData(name, calories, fat, carbs, protein) {
  let date = new Date();
  const dateP = `${date.getDate()}-${
    date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  }-${date.getFullYear()}`;
  return { name, calories, fat, carbs, protein, dateP };
}

const rowsPrueba = [
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Donut', 452, 25.0, 51, 4.9),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
  createData('Honeycomb', 408, 3.2, 87, 6.5),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Jelly Bean', 375, 0.0, 94, 0.0),
  createData('KitKat', 518, 26.0, 65, 7.0),
  createData('Lollipop', 392, 0.2, 98, 0.0),
  createData('Marshmallow', 318, 0, 81, 2.0),
  createData('Nougat', 360, 19.0, 9, 37.0),
  createData('Oreo', 437, 18.0, 63, 4.0),
];

const styleFat = content => {
  return <Chip label={content} />;
};

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    align: 'right',
    alignContent: 'left',
    label: 'Nombre',
  },
  { id: 'calories', alignContent: 'center', label: 'Calories' },
  { id: 'fat', alignContent: 'center', label: 'Fat (g)', style: styleFat },
  { id: 'carbs', alignContent: 'center', label: 'Carbs (g)' },
  { id: 'protein', alignContent: 'center', label: 'Protein (g)' },
  { id: 'dateP', alignContent: 'center', label: 'Prueba' },
];

const validaciones = [
  {
    type: 'select',
    target: 'name',
    title: 'Nombre',
    options: ['Oreo', 'KitKat'],
  },
  {
    type: 'select',
    target: 'protein',
    title: 'Proteinas',
    options: ['0', '1', '3', '4', '5'],
  },
  {
    type: 'numericRange',
    target: 'calories',
    title: 'Cal.',
  },
  {
    type: 'dateRange',
    target: 'dateP',
    title: 'Fecha',
  },
];

const actions = [
  { action: 'view', label: 'View', icon: <Visibility /> },
  { action: 'edit', label: 'Edit', icon: <Edit /> },
  { action: 'email', label: 'Email', icon: <Mail /> },
];

const handleAction = (menu, id) => {
  if (menu.action === 'view') {
  } else if (menu.action === 'edit') {
  } else if (menu.action === 'email') {
  }
};

const TablaUsuarios = () => {
  const [openDialog, setOpenDialog] = React.useState(false);

  const prueba = () => {
    setOpenDialog(true);
  };

  const onCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Fragment>
      <Dialog open={openDialog} onClose={onCloseDialog}>
        <div>hola :3</div>
      </Dialog>

      <CustomTable
        headCells={headCells}
        rows={rowsPrueba}
        title={'Nutrition'}
        validation={validaciones}
        search={true}
        actions={actions}
        handleAction={handleAction}
        add={prueba}
        addText={'Agregar :o'}
      />
    </Fragment>
  );
};

export default TablaUsuarios;
